import { GalleryImage } from 'editor/src/store/gallery/types';

// A file being uploaded is known by its uploader id; a page of a split PDF, added by the host, by its image id.
const getUploadKey = (image: Pick<GalleryImage, 'id' | 'uploaderId'>) => image.uploaderId ?? image.id;

export default getUploadKey;
